import { defineComponent as r, createBlock as n, openBlock as a, unref as c, mergeProps as p, withCtx as l, createElementVNode as m } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconTrade",
  __name: "IconTrade",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (i, e) => (a(), n(c(s), p(o, { "view-box": "0 0 24 24" }), {
      default: l(() => [...e[0] || (e[0] = [
        m("path", { d: "M3.75 10.75c0-.985.727-2.034 2.25-2.88C7.498 7.038 9.618 6.5 12 6.5s4.502.538 6 1.37c1.523.846 2.25 1.895 2.25 2.88 0 1.24-1.177 2.587-3.511 3.455a.75.75 0 1 0 .522 1.406c2.49-.926 4.489-2.634 4.489-4.861 0-1.777-1.288-3.228-3.022-4.191C16.968 5.58 14.588 5 12 5S7.032 5.581 5.272 6.559C3.537 7.522 2.25 8.973 2.25 10.75c0 1.656 1.122 3.031 2.669 3.985 1.412.87 3.282 1.464 5.358 1.678L8.97 17.72a.75.75 0 1 0 1.06 1.06l2.147-2.146a1.25 1.25 0 0 0 0-1.768L10.03 12.72a.75.75 0 1 0-1.06 1.06l1.098 1.099c-1.742-.223-3.253-.738-4.362-1.421-1.328-.819-1.956-1.79-1.956-2.708" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
